import {
	PAYFIT_CLIENT_ID,
	PAYFIT_CLIENT_SECRET,
	PAYFIT_GRANT_TYPE,
	PAYFIT_REDIRECT_URI,
	PAYFIT_SCOPES,
	PAYFIT_STATE
} from '../../../constants/PayfitConstants';

export interface PayfitTokenDto {
	code: string;
}

const getAccessToken = async (token: string, code: string): Promise<any> => {
	// Retrieve the company ID from sessionStorage if it was stored during OAuth initiation
	const companyId = sessionStorage.getItem('payfit_company_id');

	const bodyJson: any = {
		code,
		client_id: PAYFIT_CLIENT_ID,
		client_secret: PAYFIT_CLIENT_SECRET,
		redirect_uri: PAYFIT_REDIRECT_URI,
		grant_type: PAYFIT_GRANT_TYPE,
		state: PAYFIT_STATE,
		scope: PAYFIT_SCOPES
	};

	// Include company_id if it exists (for multi-company OAuth flow)
	if (companyId) {
		bodyJson.company_id = companyId;
	}

	const response = await fetch(`${process.env.REACT_APP_BASE_API}/thirdparty/payfit/token`, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`
		},
		body: JSON.stringify(bodyJson)
	});

	return response.json();
};

export default getAccessToken;
